module.exports = __webpack_public_path__ + "static/img/5.635e995.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/management/5.png
// module id = Ou8c
// module chunks = 7